<template>
  <div>
    <div class="modal is-active" v-show="showHistoryLog">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">History</p>
          <button class="delete" aria-label="close" @click="closeModal"></button>
        </header>
        <section class="modal-card-body">
          <span v-html="historyLog"></span>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <button class="button is-small" @click="closeModal">Close</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState("porequest", {
      showHistoryLog: (state) => state.showHistoryLog,
      historyLog: (state) => state.historyLog,
    }),
  },
  methods: {
    ...mapActions("porequest", ["openHistoryLogModal"]),
    closeModal(){
        this.openHistoryLogModal({
            showHistoryLog: false
        })
    }
  }
};
</script>